import { wrapAnalyticsImagesInDiv } from './utils'
// eslint-disable-next-line no-undef
const componentObserver = new MutationObserver(wrapAnalyticsImagesInDiv)

componentObserver.observe(document.body, {
  childList: true,
  subtree: true,
})

document.addEventListener('DOMContentLoaded', wrapAnalyticsImagesInDiv)
